// Comprehensive EN / FR translations for the BridgeDatum site.
// EISG microsite is French-primary and intentionally not switchable.

const EN = {
  // ---------- Nav / Footer ----------
  "nav.home": "Home",
  "nav.about": "About",
  "nav.solutions": "Solutions",
  "nav.advisory": "Advisory",
  "nav.intelligence": "Intelligence",
  "nav.sustainability": "Sustainability",
  "nav.sectors": "Sectors",
  "nav.insights": "Insights",
  "nav.contact": "Contact",
  "nav.eisg": "EISG",

  "footer.tagline": "AI · Data · Governance · Sustainability · Execution",
  "footer.desc": "BridgeDatum helps African institutions become AI-ready, data-driven, governance-led and sustainability-aligned.",
  "footer.label": "A Strategic Transformation Company",
  "footer.navigate": "Navigate",
  "footer.contact": "Contact",
  "footer.address": "Centurion, South Africa — Johannesburg · Cape Town",
  "footer.rights": "All rights reserved.",
  "footer.visitEisg": "Visit EISG",

  // ---------- Home ----------
  "home.hero.eyebrow": "AI · DATA · GOVERNANCE · SUSTAINABILITY · EXECUTION",
  "home.hero.headline": "Building AI-Ready and Governance-Led Institutions for Africa",
  "home.hero.subtitle": "AI · Data · Governance · Sustainability · Execution.",
  "home.hero.body": "BridgeDatum helps organisations govern transformation, deploy AI responsibly, convert data into decisions, strengthen institutional performance and create measurable impact.",
  "home.hero.cta.solutions": "Explore Solutions",
  "home.hero.cta.eisg": "Discover EISG",
  "home.stats.countries": "African countries",
  "home.stats.executive": "Executive",
  "home.stats.disciplines": "Disciplines",

  "home.pillars.number": "— 01",
  "home.pillars.eyebrow": "Core Pillars",
  "home.pillars.title": "Five disciplines. One transformation thesis.",
  "home.pillars.subtitle": "Five levers to transform African institutions in the age of AI.",
  "home.pillars.body": "BridgeDatum operates across five strategic disciplines to make transformation a durable institutional advantage.",
  "home.pillars.ai.title": "AI & Digital Transformation",
  "home.pillars.ai.desc": "AI-readiness, use-case mapping, digital transformation roadmaps and responsible AI deployment.",
  "home.pillars.data.title": "Data & Decision Intelligence",
  "home.pillars.data.desc": "Dashboards, diagnostics, scorecards, analytics and executive decision-support systems.",
  "home.pillars.gov.title": "Governance & Institutional Performance",
  "home.pillars.gov.desc": "Governance frameworks, accountability systems, risk, compliance and institutional performance.",
  "home.pillars.sus.title": "Sustainability & Impact",
  "home.pillars.sus.desc": "ESG, mining sustainability, social performance, agriculture, climate-smart development and impact measurement.",
  "home.pillars.exec.title": "Executive Capability",
  "home.pillars.exec.desc": "Executive education and leadership transformation delivered through EISG.",

  "home.approach.number": "— 02 · APPROACH",
  "home.approach.quote.a": "Artificial intelligence can no longer be delegated.",
  "home.approach.quote.b": "It must be governed.",
  "home.approach.body": "BridgeDatum aligns strategy, data, governance and execution to turn African institutions into AI-ready, governance-led and sustainably high-performing organisations.",

  "home.eisgBridge.number": "— 03",
  "home.eisgBridge.eyebrow": "A BridgeDatum Institute",
  "home.eisgBridge.title": "EISG — Executive Institute of Strategy and Governance",
  "home.eisgBridge.subtitle": "Executive Institute of Strategy and Governance.",
  "home.eisgBridge.body": "Through EISG, BridgeDatum equips African executives, boards, senior managers and institutional leaders with the capability to govern AI, lead transformation and create value.",
  "home.eisgBridge.moment": "MOMENT",
  "home.eisgBridge.pilotage": "Pilotage",
  "home.eisgBridge.command": "Command",
  "home.eisgBridge.functions": "Functions",
  "home.eisgBridge.cta": "Visit EISG Website",

  "home.cta.title": "Ready to govern your transformation and create measurable value?",
  "home.cta.btn": "Speak to BridgeDatum",

  // ---------- About ----------
  "about.hero.eyebrow": "— ABOUT BRIDGEDATUM",
  "about.hero.title": "The strategic transformation company for African institutions.",
  "about.hero.body": "BridgeDatum combines advisory, intelligence, capability and execution to help African organisations become AI-ready, data-driven, governance-led and sustainability-aligned.",

  "about.thesis.number": "— 01",
  "about.thesis.eyebrow": "Our Thesis",
  "about.thesis.title": "Africa's next decade will be won by AI-ready, governance-led institutions.",
  "about.thesis.p1": "The institutional question of the next decade is not whether to adopt AI — it is how to govern transformation. BridgeDatum exists to help boards, executives, ministries and operators answer that question with rigour, evidence and execution discipline.",
  "about.thesis.p2": "We translate strategy into data architectures, governance frameworks, executive capability and operational systems that deliver measurable institutional value across the continent.",

  "about.values.number": "— 02",
  "about.values.eyebrow": "Values",
  "about.values.title": "How we think. How we work.",
  "about.values.0.title": "Strategy first",
  "about.values.0.desc": "We work from outcomes, not technology. Every engagement starts with a board-level strategic thesis.",
  "about.values.1.title": "Governance-led",
  "about.values.1.desc": "AI deployment without governance is institutional risk. We design accountability before deployment.",
  "about.values.2.title": "African by design",
  "about.values.2.desc": "Frameworks calibrated to African institutional realities, talent markets and regulatory landscapes.",
  "about.values.3.title": "Measurable impact",
  "about.values.3.desc": "Every transformation tracked through executive scorecards and impact metrics.",

  "about.footprint.number": "— 03 · FOOTPRINT",
  "about.footprint.title": "Centurion. Johannesburg. Cape Town.",
  "about.footprint.accent": "All of Africa.",
  "about.footprint.body": "BridgeDatum operates from South Africa with engagements across mining belts, financial capitals, public institutions and development organisations on the continent.",

  // ---------- Solutions ----------
  "sol.hero.number": "— SOLUTIONS",
  "sol.hero.eyebrow": "What We Deliver",
  "sol.hero.title": "From strategic thesis to operational execution.",
  "sol.hero.subtitle": "Five integrated disciplines. One transformation thesis.",
  "sol.hero.body": "BridgeDatum delivers integrated solutions across five disciplines — designed for African institutional realities.",

  "sol.ai.title": "AI & Digital Transformation",
  "sol.ai.desc": "AI-readiness assessment, use-case mapping, responsible AI deployment, digital transformation roadmaps.",
  "sol.ai.0": "AI maturity diagnostics",
  "sol.ai.1": "Use-case portfolios",
  "sol.ai.2": "Roadmap design",
  "sol.ai.3": "Responsible AI frameworks",
  "sol.data.title": "Data & Decision Intelligence",
  "sol.data.desc": "Executive dashboards, diagnostics, scorecards, predictive analytics, decision-support systems.",
  "sol.data.0": "Executive dashboards",
  "sol.data.1": "Data diagnostics",
  "sol.data.2": "Predictive analytics",
  "sol.data.3": "Decision systems",
  "sol.gov.title": "Governance & Institutional Performance",
  "sol.gov.desc": "Governance frameworks, accountability systems, risk, compliance and institutional performance management.",
  "sol.gov.0": "AI governance",
  "sol.gov.1": "Risk & compliance",
  "sol.gov.2": "Accountability systems",
  "sol.gov.3": "Board reporting",
  "sol.sus.title": "Sustainability & Impact",
  "sol.sus.desc": "ESG strategy, mining sustainability, social performance, climate-smart agriculture, impact measurement.",
  "sol.sus.0": "ESG frameworks",
  "sol.sus.1": "Mining sustainability",
  "sol.sus.2": "Climate-smart strategy",
  "sol.sus.3": "Impact metrics",
  "sol.exec.title": "Executive Capability (EISG)",
  "sol.exec.desc": "Executive education and leadership transformation delivered through EISG — our Executive Institute of Strategy and Governance.",
  "sol.exec.0": "Programme Phare",
  "sol.exec.1": "AI Executive Command",
  "sol.exec.2": "Sessions Augmentées",
  "sol.exec.3": "In-house seminars",
  "sol.exec.link": "Discover EISG",

  // ---------- Advisory ----------
  "adv.hero.eyebrow": "— ADVISORY",
  "adv.hero.title.a": "Strategic advisory",
  "adv.hero.title.b": "for boards, executives and ministries.",
  "adv.hero.body": "Discreet, senior, high-stakes advisory for institutions navigating transformation, AI governance, performance and risk.",
  "adv.engagement.number": "— 01",
  "adv.engagement.eyebrow": "Engagement Model",
  "adv.engagement.title": "Three modes of advisory engagement.",
  "adv.engagement.0.label": "Strategic",
  "adv.engagement.0.desc": "Quarterly board engagement on AI, governance, transformation.",
  "adv.engagement.1.label": "Programmatic",
  "adv.engagement.1.desc": "12–24 month transformation programmes with embedded BridgeDatum teams.",
  "adv.engagement.2.label": "Tactical",
  "adv.engagement.2.desc": "Targeted interventions on diagnostics, frameworks or executive arbitration.",
  "adv.coverage.number": "— 02",
  "adv.coverage.eyebrow": "Coverage",
  "adv.coverage.title": "Where BridgeDatum advises.",
  "adv.services.0": "Board advisory and AI governance",
  "adv.services.1": "Executive strategy retreats",
  "adv.services.2": "Maturity diagnostics and roadmaps",
  "adv.services.3": "Digital transformation programmes",
  "adv.services.4": "Risk, compliance and accountability frameworks",
  "adv.services.5": "Public sector and ministerial advisory",
  "adv.services.6": "Mining and ESG transformation",
  "adv.services.7": "Institutional performance management",
  "adv.cta.title": "Engage BridgeDatum on a discreet advisory mandate.",
  "adv.cta.btn": "Request a conversation",

  // ---------- Intelligence ----------
  "intel.hero.eyebrow": "— INTELLIGENCE & PLATFORMS",
  "intel.hero.title.a": "From data to",
  "intel.hero.title.b": "decisions.",
  "intel.hero.body": "We build executive-grade intelligence platforms that turn institutional data into measurable strategic decisions.",
  "intel.platforms.number": "— 01",
  "intel.platforms.eyebrow": "Platforms",
  "intel.platforms.title": "Decision-grade intelligence — built for executives.",
  "intel.platforms.0.title": "Executive Scorecards",
  "intel.platforms.0.desc": "Board-ready scorecards translating strategy, risk and performance into a single executive view.",
  "intel.platforms.1.title": "Decision Dashboards",
  "intel.platforms.1.desc": "Operational and tactical dashboards for ministries, mining operators, banks and institutions.",
  "intel.platforms.2.title": "AI Diagnostics",
  "intel.platforms.2.desc": "Institutional AI-readiness diagnostics with maturity scoring, use-case mapping and risk register.",
  "intel.platforms.3.title": "Impact Intelligence",
  "intel.platforms.3.desc": "ESG, social performance and impact measurement platforms with audit-grade traceability.",
  "intel.quote.a": "A dashboard that doesn't change a decision is a",
  "intel.quote.b": "report",
  "intel.quote.c": ", not intelligence.",
  "intel.quote.attr": "— BridgeDatum Intelligence Principle",

  // ---------- Sustainability ----------
  "sus.hero.eyebrow": "— SUSTAINABILITY & IMPACT",
  "sus.hero.title.a": "Convert engagements into",
  "sus.hero.title.b": "measurable impact.",
  "sus.hero.body": "BridgeDatum helps mining, agriculture, social and public institutions translate ESG and sustainability into operational performance.",
  "sus.pillars.number": "— 01",
  "sus.pillars.eyebrow": "Focus Areas",
  "sus.pillars.title": "Six dimensions of measurable impact.",
  "sus.pillars.0.title": "Mining Sustainability",
  "sus.pillars.0.desc": "ESG transformation, social performance, community engagement and rehabilitation for mining operators.",
  "sus.pillars.1.title": "Climate-Smart Agriculture",
  "sus.pillars.1.desc": "Agricultural value chains, climate resilience, smallholder integration and food systems strategy.",
  "sus.pillars.2.title": "Social Performance",
  "sus.pillars.2.desc": "Health, education and development programmes with measurable social outcomes and accountability.",
  "sus.pillars.3.title": "ESG Strategy",
  "sus.pillars.3.desc": "Board-level ESG frameworks aligned with investor, regulator and community expectations.",
  "sus.pillars.4.title": "Impact Measurement",
  "sus.pillars.4.desc": "Audit-grade impact metrics, monitoring frameworks and executive reporting.",
  "sus.pillars.5.title": "Responsible Operations",
  "sus.pillars.5.desc": "Risk, ethics and conformity systems for resource and infrastructure sectors.",

  // ---------- Sectors ----------
  "sec.hero.number": "— SECTORS",
  "sec.hero.eyebrow": "Where We Operate",
  "sec.hero.title": "Sector solutions for African institutional realities.",
  "sec.hero.body": "BridgeDatum delivers tailored programmes for the sectors that drive Africa's institutional transformation.",
  "sec.items.0.title": "Public Sector",
  "sec.items.0.desc": "Ministries, agencies, local authorities, regulators and public institutions.",
  "sec.items.1.title": "Mining & Resources",
  "sec.items.1.desc": "Mining operators, refineries, energy, critical infrastructure.",
  "sec.items.2.title": "Agriculture & Agribusiness",
  "sec.items.2.desc": "Agricultural value chains, processing, climate-smart agriculture.",
  "sec.items.3.title": "Banking & Finance",
  "sec.items.3.desc": "Commercial banks, microfinance, insurance, capital markets.",
  "sec.items.4.title": "Health & Social",
  "sec.items.4.desc": "Hospitals, social programmes, NGOs, multilateral organisations.",
  "sec.items.5.title": "Industry & Services",
  "sec.items.5.desc": "Manufacturing, telecoms, distribution, business services.",

  // ---------- Insights ----------
  "ins.hero.eyebrow": "— INSIGHTS",
  "ins.hero.title.a": "Editorial.",
  "ins.hero.title.b": "Strategic.",
  "ins.hero.title.c": "Executive.",
  "ins.hero.body": "Perspectives on AI governance, data intelligence, sustainability and institutional transformation in Africa.",
  "ins.items.0.tag": "AI Governance",
  "ins.items.0.title": "Why AI governance is the new corporate governance in Africa",
  "ins.items.0.date": "February 2026",
  "ins.items.0.excerpt": "African boards must integrate AI as a top-tier strategic risk.",
  "ins.items.1.tag": "Data Intelligence",
  "ins.items.1.title": "From dashboard to decision: 5 classic mistakes to avoid",
  "ins.items.1.date": "January 2026",
  "ins.items.1.excerpt": "Building executive decision systems that actually change board-level arbitrations.",
  "ins.items.2.tag": "Sustainability",
  "ins.items.2.title": "Mining ESG: turning commitments into measurable performance",
  "ins.items.2.date": "December 2025",
  "ins.items.2.excerpt": "An operational framework for measuring social and environmental impact.",
  "ins.items.cta": "Read the analysis",
  "ins.footer": "New BridgeDatum Insights are published each quarter.",

  // ---------- Contact ----------
  "ct.hero.number": "— CONTACT",
  "ct.hero.eyebrow": "Talk to BridgeDatum",
  "ct.hero.title": "Engage on strategy, advisory, intelligence or transformation.",
  "ct.hero.subtitle": "Premium, discreet and senior — scoped within 48 hours.",
  "ct.hero.body": "Reach our partners directly for board mandates, ministerial advisory or institutional programmes.",
  "ct.direct.eyebrow": "— Direct Lines",
  "ct.direct.title": "Where to reach us.",
  "ct.direct.email": "Email",
  "ct.direct.whatsapp": "WhatsApp South Africa",
  "ct.direct.base": "Base",
  "ct.direct.locations": "Locations: Johannesburg · Cape Town",
  "ct.direct.address": "Centurion, South Africa",
  "ct.form.eyebrow": "Talk to Us",
  "ct.form.title": "Send a message",
  "ct.form.name": "Full name",
  "ct.form.email": "Email",
  "ct.form.org": "Organisation",
  "ct.form.subject": "Subject",
  "ct.form.message": "Message",
  "ct.form.required": "*",
  "ct.form.submit": "Send Message",
  "ct.form.success": "Message sent. We will reply within 48 hours.",
  "ct.form.error": "Something went wrong. Please retry or email contact@bridgedatum.com.",
  "ct.form.validation": "Please fill in name, email and message.",
};

const FR = {
  // ---------- Nav / Footer ----------
  "nav.home": "Accueil",
  "nav.about": "À propos",
  "nav.solutions": "Solutions",
  "nav.advisory": "Conseil",
  "nav.intelligence": "Intelligence",
  "nav.sustainability": "Durabilité",
  "nav.sectors": "Secteurs",
  "nav.insights": "Insights",
  "nav.contact": "Contact",
  "nav.eisg": "EISG",

  "footer.tagline": "IA · Données · Gouvernance · Durabilité · Exécution",
  "footer.desc": "BridgeDatum accompagne les institutions africaines pour devenir AI-ready, data-driven, governance-led et alignées sur la durabilité.",
  "footer.label": "Une société de transformation stratégique",
  "footer.navigate": "Naviguer",
  "footer.contact": "Contact",
  "footer.address": "Centurion, Afrique du Sud — Johannesburg · Cape Town",
  "footer.rights": "Tous droits réservés.",
  "footer.visitEisg": "Visiter EISG",

  // ---------- Home ----------
  "home.hero.eyebrow": "IA · DONNÉES · GOUVERNANCE · DURABILITÉ · EXÉCUTION",
  "home.hero.headline": "Construire des institutions africaines AI-ready et gouvernance-led",
  "home.hero.subtitle": "IA · Données · Gouvernance · Durabilité · Exécution.",
  "home.hero.body": "BridgeDatum accompagne les organisations pour gouverner la transformation, déployer l'IA de manière responsable, transformer les données en décisions, renforcer la performance institutionnelle et créer un impact mesurable.",
  "home.hero.cta.solutions": "Découvrir les solutions",
  "home.hero.cta.eisg": "Découvrir EISG",
  "home.stats.countries": "Pays africains",
  "home.stats.executive": "Exécutif",
  "home.stats.disciplines": "Disciplines",

  "home.pillars.number": "— 01",
  "home.pillars.eyebrow": "Piliers stratégiques",
  "home.pillars.title": "Cinq disciplines. Une thèse de transformation.",
  "home.pillars.subtitle": "Cinq leviers pour transformer les institutions africaines à l'ère de l'IA.",
  "home.pillars.body": "BridgeDatum opère sur cinq disciplines stratégiques pour faire de la transformation un avantage institutionnel durable.",
  "home.pillars.ai.title": "IA & Transformation Digitale",
  "home.pillars.ai.desc": "Maturité IA, cartographie des cas d'usage, feuilles de route et déploiement responsable.",
  "home.pillars.data.title": "Données & Intelligence Décisionnelle",
  "home.pillars.data.desc": "Dashboards, diagnostics, scorecards, analytique et systèmes de décision exécutifs.",
  "home.pillars.gov.title": "Gouvernance & Performance Institutionnelle",
  "home.pillars.gov.desc": "Cadres de gouvernance, redevabilité, risque, conformité et performance institutionnelle.",
  "home.pillars.sus.title": "Durabilité & Impact",
  "home.pillars.sus.desc": "ESG, durabilité minière, performance sociale, agriculture, climat et mesure d'impact.",
  "home.pillars.exec.title": "Capacités Exécutives",
  "home.pillars.exec.desc": "Formation exécutive et transformation du leadership délivrée par EISG.",

  "home.approach.number": "— 02 · APPROCHE",
  "home.approach.quote.a": "L'intelligence artificielle ne se délègue plus.",
  "home.approach.quote.b": "Elle se gouverne.",
  "home.approach.body": "BridgeDatum aligne la stratégie, la donnée, la gouvernance et l'exécution pour transformer les institutions africaines en organisations AI-ready, gouvernance-led et durablement performantes.",

  "home.eisgBridge.number": "— 03",
  "home.eisgBridge.eyebrow": "Une division de BridgeDatum",
  "home.eisgBridge.title": "EISG — Institut Exécutif de Stratégie et de Gouvernance",
  "home.eisgBridge.subtitle": "Institut Exécutif de Stratégie et de Gouvernance.",
  "home.eisgBridge.body": "À travers EISG, BridgeDatum dote les dirigeants africains, conseils d'administration, hauts cadres et décideurs institutionnels de la capacité à gouverner l'IA, piloter la transformation et créer de la valeur.",
  "home.eisgBridge.moment": "MOMENT",
  "home.eisgBridge.pilotage": "Pilotage",
  "home.eisgBridge.command": "Commandement",
  "home.eisgBridge.functions": "Métiers",
  "home.eisgBridge.cta": "Visiter le site EISG",

  "home.cta.title": "Prêt à gouverner votre transformation et créer de la valeur mesurable ?",
  "home.cta.btn": "Parler à BridgeDatum",

  // ---------- About ----------
  "about.hero.eyebrow": "— À PROPOS DE BRIDGEDATUM",
  "about.hero.title": "La société de transformation stratégique des institutions africaines.",
  "about.hero.body": "BridgeDatum combine conseil, intelligence, capacités et exécution pour aider les organisations africaines à devenir AI-ready, data-driven, governance-led et alignées sur la durabilité.",

  "about.thesis.number": "— 01",
  "about.thesis.eyebrow": "Notre thèse",
  "about.thesis.title": "La prochaine décennie en Afrique sera gagnée par les institutions AI-ready et governance-led.",
  "about.thesis.p1": "La question institutionnelle de la prochaine décennie n'est pas d'adopter l'IA — c'est de gouverner la transformation. BridgeDatum existe pour aider les conseils d'administration, dirigeants, ministères et opérateurs à y répondre avec rigueur, données et discipline d'exécution.",
  "about.thesis.p2": "Nous traduisons la stratégie en architectures de données, cadres de gouvernance, capacités exécutives et systèmes opérationnels qui délivrent une valeur institutionnelle mesurable à travers le continent.",

  "about.values.number": "— 02",
  "about.values.eyebrow": "Valeurs",
  "about.values.title": "Comment nous pensons. Comment nous travaillons.",
  "about.values.0.title": "Stratégie d'abord",
  "about.values.0.desc": "Nous partons des résultats, pas de la technologie. Chaque mission démarre par une thèse stratégique au niveau du conseil.",
  "about.values.1.title": "Gouvernance d'abord",
  "about.values.1.desc": "Déployer l'IA sans gouvernance, c'est un risque institutionnel. Nous concevons la redevabilité avant le déploiement.",
  "about.values.2.title": "Africain par conception",
  "about.values.2.desc": "Cadres calibrés sur les réalités institutionnelles africaines, les marchés du talent et les paysages réglementaires.",
  "about.values.3.title": "Impact mesurable",
  "about.values.3.desc": "Chaque transformation suivie via des scorecards exécutifs et des métriques d'impact.",

  "about.footprint.number": "— 03 · PRÉSENCE",
  "about.footprint.title": "Centurion. Johannesburg. Cape Town.",
  "about.footprint.accent": "Toute l'Afrique.",
  "about.footprint.body": "BridgeDatum opère depuis l'Afrique du Sud avec des missions à travers les ceintures minières, les capitales financières, les institutions publiques et les organisations de développement du continent.",

  // ---------- Solutions ----------
  "sol.hero.number": "— SOLUTIONS",
  "sol.hero.eyebrow": "Ce que nous délivrons",
  "sol.hero.title": "De la thèse stratégique à l'exécution opérationnelle.",
  "sol.hero.subtitle": "Cinq disciplines intégrées. Une thèse de transformation.",
  "sol.hero.body": "BridgeDatum délivre des solutions intégrées sur cinq disciplines — conçues pour les réalités institutionnelles africaines.",

  "sol.ai.title": "IA & Transformation Digitale",
  "sol.ai.desc": "Évaluation de la maturité IA, cartographie des cas d'usage, déploiement responsable, feuilles de route de transformation digitale.",
  "sol.ai.0": "Diagnostics de maturité IA",
  "sol.ai.1": "Portefeuilles de cas d'usage",
  "sol.ai.2": "Conception de feuille de route",
  "sol.ai.3": "Cadres d'IA responsable",
  "sol.data.title": "Données & Intelligence Décisionnelle",
  "sol.data.desc": "Dashboards exécutifs, diagnostics, scorecards, analytique prédictive, systèmes d'aide à la décision.",
  "sol.data.0": "Dashboards exécutifs",
  "sol.data.1": "Diagnostics data",
  "sol.data.2": "Analytique prédictive",
  "sol.data.3": "Systèmes décisionnels",
  "sol.gov.title": "Gouvernance & Performance Institutionnelle",
  "sol.gov.desc": "Cadres de gouvernance, systèmes de redevabilité, risque, conformité et pilotage de la performance institutionnelle.",
  "sol.gov.0": "Gouvernance de l'IA",
  "sol.gov.1": "Risque & conformité",
  "sol.gov.2": "Systèmes de redevabilité",
  "sol.gov.3": "Reporting conseil",
  "sol.sus.title": "Durabilité & Impact",
  "sol.sus.desc": "Stratégie ESG, durabilité minière, performance sociale, agriculture climato-intelligente, mesure d'impact.",
  "sol.sus.0": "Cadres ESG",
  "sol.sus.1": "Durabilité minière",
  "sol.sus.2": "Stratégie climato-intelligente",
  "sol.sus.3": "Métriques d'impact",
  "sol.exec.title": "Capacités Exécutives (EISG)",
  "sol.exec.desc": "Formation exécutive et transformation du leadership délivrée par EISG — notre Institut Exécutif de Stratégie et de Gouvernance.",
  "sol.exec.0": "Programme Phare",
  "sol.exec.1": "AI Executive Command",
  "sol.exec.2": "Sessions Augmentées",
  "sol.exec.3": "Séminaires in-house",
  "sol.exec.link": "Découvrir EISG",

  // ---------- Advisory ----------
  "adv.hero.eyebrow": "— CONSEIL",
  "adv.hero.title.a": "Conseil stratégique",
  "adv.hero.title.b": "pour conseils, dirigeants et ministères.",
  "adv.hero.body": "Conseil discret, senior et à fort enjeu pour les institutions qui pilotent transformation, gouvernance de l'IA, performance et risque.",
  "adv.engagement.number": "— 01",
  "adv.engagement.eyebrow": "Modèle d'engagement",
  "adv.engagement.title": "Trois modes d'engagement conseil.",
  "adv.engagement.0.label": "Stratégique",
  "adv.engagement.0.desc": "Engagement trimestriel au niveau du conseil sur l'IA, la gouvernance et la transformation.",
  "adv.engagement.1.label": "Programmatique",
  "adv.engagement.1.desc": "Programmes de transformation de 12 à 24 mois avec équipes BridgeDatum intégrées.",
  "adv.engagement.2.label": "Tactique",
  "adv.engagement.2.desc": "Interventions ciblées : diagnostics, cadres ou arbitrage exécutif.",
  "adv.coverage.number": "— 02",
  "adv.coverage.eyebrow": "Couverture",
  "adv.coverage.title": "Où BridgeDatum intervient.",
  "adv.services.0": "Conseil au conseil d'administration et gouvernance de l'IA",
  "adv.services.1": "Séminaires stratégie exécutive",
  "adv.services.2": "Diagnostics de maturité et feuilles de route",
  "adv.services.3": "Programmes de transformation digitale",
  "adv.services.4": "Cadres de risque, conformité et redevabilité",
  "adv.services.5": "Conseil au secteur public et aux ministères",
  "adv.services.6": "Transformation minière et ESG",
  "adv.services.7": "Pilotage de la performance institutionnelle",
  "adv.cta.title": "Engagez BridgeDatum sur un mandat de conseil discret.",
  "adv.cta.btn": "Demander un échange",

  // ---------- Intelligence ----------
  "intel.hero.eyebrow": "— INTELLIGENCE & PLATEFORMES",
  "intel.hero.title.a": "De la donnée aux",
  "intel.hero.title.b": "décisions.",
  "intel.hero.body": "Nous construisons des plateformes d'intelligence exécutive qui transforment les données institutionnelles en décisions stratégiques mesurables.",
  "intel.platforms.number": "— 01",
  "intel.platforms.eyebrow": "Plateformes",
  "intel.platforms.title": "Intelligence décisionnelle — conçue pour les dirigeants.",
  "intel.platforms.0.title": "Scorecards Exécutifs",
  "intel.platforms.0.desc": "Scorecards pour conseils traduisant stratégie, risque et performance en une vue exécutive unique.",
  "intel.platforms.1.title": "Dashboards Décisionnels",
  "intel.platforms.1.desc": "Dashboards opérationnels et tactiques pour ministères, opérateurs miniers, banques et institutions.",
  "intel.platforms.2.title": "Diagnostics IA",
  "intel.platforms.2.desc": "Diagnostics institutionnels de maturité IA avec scoring, cartographie des cas d'usage et registre des risques.",
  "intel.platforms.3.title": "Intelligence d'Impact",
  "intel.platforms.3.desc": "Plateformes ESG, performance sociale et mesure d'impact avec traçabilité de niveau audit.",
  "intel.quote.a": "Un dashboard qui ne change pas une décision est un",
  "intel.quote.b": "rapport",
  "intel.quote.c": ", pas de l'intelligence.",
  "intel.quote.attr": "— Principe BridgeDatum Intelligence",

  // ---------- Sustainability ----------
  "sus.hero.eyebrow": "— DURABILITÉ & IMPACT",
  "sus.hero.title.a": "Convertir les engagements en",
  "sus.hero.title.b": "impact mesurable.",
  "sus.hero.body": "BridgeDatum aide les institutions minières, agricoles, sociales et publiques à traduire l'ESG et la durabilité en performance opérationnelle.",
  "sus.pillars.number": "— 01",
  "sus.pillars.eyebrow": "Domaines d'intervention",
  "sus.pillars.title": "Six dimensions d'impact mesurable.",
  "sus.pillars.0.title": "Durabilité Minière",
  "sus.pillars.0.desc": "Transformation ESG, performance sociale, engagement communautaire et réhabilitation pour les opérateurs miniers.",
  "sus.pillars.1.title": "Agriculture Climato-Intelligente",
  "sus.pillars.1.desc": "Chaînes de valeur agricoles, résilience climatique, intégration des petits producteurs et stratégie des systèmes alimentaires.",
  "sus.pillars.2.title": "Performance Sociale",
  "sus.pillars.2.desc": "Programmes santé, éducation et développement avec résultats sociaux mesurables et redevabilité.",
  "sus.pillars.3.title": "Stratégie ESG",
  "sus.pillars.3.desc": "Cadres ESG au niveau conseil alignés sur les attentes investisseurs, régulateurs et communautés.",
  "sus.pillars.4.title": "Mesure d'Impact",
  "sus.pillars.4.desc": "Métriques d'impact de niveau audit, cadres de suivi et reporting exécutif.",
  "sus.pillars.5.title": "Opérations Responsables",
  "sus.pillars.5.desc": "Systèmes de risque, éthique et conformité pour les secteurs des ressources et infrastructures.",

  // ---------- Sectors ----------
  "sec.hero.number": "— SECTEURS",
  "sec.hero.eyebrow": "Où nous opérons",
  "sec.hero.title": "Solutions sectorielles pour les réalités institutionnelles africaines.",
  "sec.hero.body": "BridgeDatum délivre des programmes sur mesure pour les secteurs qui pilotent la transformation institutionnelle de l'Afrique.",
  "sec.items.0.title": "Secteur public",
  "sec.items.0.desc": "Ministères, agences, collectivités, régulateurs et institutions publiques.",
  "sec.items.1.title": "Mines & ressources",
  "sec.items.1.desc": "Opérateurs miniers, raffineries, énergie, infrastructures critiques.",
  "sec.items.2.title": "Agriculture & agro-industrie",
  "sec.items.2.desc": "Chaînes de valeur agricoles, transformation, agriculture climato-intelligente.",
  "sec.items.3.title": "Banque & finance",
  "sec.items.3.desc": "Banques commerciales, microfinance, assurance, marchés de capitaux.",
  "sec.items.4.title": "Santé & social",
  "sec.items.4.desc": "Hôpitaux, programmes sociaux, ONG, organisations multilatérales.",
  "sec.items.5.title": "Industrie & services",
  "sec.items.5.desc": "Manufacturing, télécoms, distribution, services aux entreprises.",

  // ---------- Insights ----------
  "ins.hero.eyebrow": "— INSIGHTS",
  "ins.hero.title.a": "Éditorial.",
  "ins.hero.title.b": "Stratégique.",
  "ins.hero.title.c": "Exécutif.",
  "ins.hero.body": "Perspectives sur la gouvernance de l'IA, l'intelligence des données, la durabilité et la transformation institutionnelle en Afrique.",
  "ins.items.0.tag": "Gouvernance IA",
  "ins.items.0.title": "Pourquoi la gouvernance de l'IA est la nouvelle gouvernance d'entreprise en Afrique",
  "ins.items.0.date": "Février 2026",
  "ins.items.0.excerpt": "Les conseils d'administration africains doivent intégrer l'IA comme un risque stratégique de premier rang.",
  "ins.items.1.tag": "Intelligence Données",
  "ins.items.1.title": "Du dashboard à la décision : 5 erreurs classiques à éviter",
  "ins.items.1.date": "Janvier 2026",
  "ins.items.1.excerpt": "Construire des systèmes de décision exécutifs qui changent réellement les arbitrages.",
  "ins.items.2.tag": "Durabilité",
  "ins.items.2.title": "ESG minier : convertir les engagements en performance mesurable",
  "ins.items.2.date": "Décembre 2025",
  "ins.items.2.excerpt": "Un cadre opérationnel pour mesurer l'impact social et environnemental.",
  "ins.items.cta": "Lire l'analyse",
  "ins.footer": "De nouvelles publications BridgeDatum Insights sont ajoutées chaque trimestre.",

  // ---------- Contact ----------
  "ct.hero.number": "— CONTACT",
  "ct.hero.eyebrow": "Parlez à BridgeDatum",
  "ct.hero.title": "Engagez-nous sur la stratégie, le conseil, l'intelligence ou la transformation.",
  "ct.hero.subtitle": "Premium, discret et senior — cadré sous 48 heures.",
  "ct.hero.body": "Joignez directement nos partenaires pour mandats conseil, conseil ministériel ou programmes institutionnels.",
  "ct.direct.eyebrow": "— Lignes directes",
  "ct.direct.title": "Comment nous joindre.",
  "ct.direct.email": "Email",
  "ct.direct.whatsapp": "WhatsApp Afrique du Sud",
  "ct.direct.base": "Siège",
  "ct.direct.locations": "Locations : Johannesburg · Cape Town",
  "ct.direct.address": "Centurion, Afrique du Sud",
  "ct.form.eyebrow": "Parlez-nous",
  "ct.form.title": "Envoyer un message",
  "ct.form.name": "Nom et prénom",
  "ct.form.email": "Email",
  "ct.form.org": "Organisation",
  "ct.form.subject": "Sujet",
  "ct.form.message": "Message",
  "ct.form.required": "*",
  "ct.form.submit": "Envoyer le message",
  "ct.form.success": "Message envoyé. Nous reviendrons vers vous sous 48 heures.",
  "ct.form.error": "Une erreur est survenue. Réessayez ou écrivez à contact@bridgedatum.com.",
  "ct.form.validation": "Veuillez renseigner nom, email et message.",
};

export const TRANSLATIONS = { en: EN, fr: FR };
